// src/components/vendor/QuickActions.jsx
import React from 'react';
import {
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  IconButton,
  Stack,
} from '@mui/material';
import {
  Add,
  Inventory,
  ShoppingCart,
  Message,
  TrendingUp,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      title: 'Add Product',
      icon: <Add />,
      color: '#d32f2f',
      onClick: () => navigate('/vendor/products?action=add'),
    },
    {
      title: 'Manage Orders',
      icon: <ShoppingCart />,
      color: '#2196f3',
      onClick: () => navigate('/vendor/orders'),
    },
    {
      title: 'Check Stock',
      icon: <Inventory />,
      color: '#4caf50',
      onClick: () => navigate('/vendor/products?filter=low-stock'),
    },
    {
      title: 'View Analytics',
      icon: <TrendingUp />,
      color: '#ff9800',
      onClick: () => navigate('/vendor/analytics'),
    },
    {
      title: 'Messages',
      icon: <Message />,
      color: '#9c27b0',
      onClick: () => navigate('/vendor/chat'),
    },
  ];

  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
        Quick Actions
      </Typography>
      <Grid container spacing={2}>
        {actions.map((action, index) => (
          <Grid item xs={6} key={index}>
            <Card
              sx={{
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: 3,
                },
              }}
              onClick={action.onClick}
            >
              <CardContent sx={{ textAlign: 'center', py: 2 }}>
                <IconButton
                  sx={{
                    bgcolor: `${action.color}15`,
                    color: action.color,
                    '&:hover': {
                      bgcolor: `${action.color}25`,
                    },
                  }}
                >
                  {action.icon}
                </IconButton>
                <Typography variant="body2" fontWeight="600" sx={{ mt: 1 }}>
                  {action.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default QuickActions;